import React, { useState } from "react";
import OccasionAndNeedTable from "./OccasionAndNeedTable";

const NeedsOverall = ({
  needsTableData,
  needQuestion,
  loading,
  hideShowIndex,
}) => {
  const [indexChecked, setIndexChecked] = useState(false);

  const handleIndexToggle = (checked) => {
    setIndexChecked(checked);
  };

  return (
    <div className="occasion-overall">
      <OccasionAndNeedTable
        headerText={
          <span>
            XMOT<sup>&reg;</sup> Needs - All
          </span>
        }
        headerSubTitle={
          <span>
            Base: XMOT<sup>&reg;</sup> Surveys
          </span>
        }
        subTitle={`% of survey responses`}
        tableData={needsTableData}
        question={needQuestion}
        handleIndexToggle={handleIndexToggle}
        indexChecked={indexChecked}
        loading={loading}
        hideShowIndex={hideShowIndex}
      />
    </div>
  );
};

export default NeedsOverall;
